import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from '@services/form/form.service';
import { DeliveryNote } from '../../../models/deliveryNote';
import { DeliveryNotesService } from '../../../services/entity/delivery-notes.service';

@Component({
  selector: 'app-delete-delivery-note-dialog-content',
  templateUrl: './delete-delivery-note-dialog-content.html',
  styleUrls: ['./delete-delivery-note-dialog-content.scss'],
  providers: [FormService]
})
export class DeleteDeliveryNoteDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'DeleteDeliveryNoteDialogContentComponent';
  @Input() private entity: DeliveryNote;
  public form: UntypedFormGroup;

  

  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    private deliveryNotesService: DeliveryNotesService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();

  }

  deleteDeliveryNote() {
    this.deliveryNotesService.deleteEntity(this.entity.id).subscribe(result => {
      this.activeModal.close({ success: true });
    }, error => {
      this.messageService.setError(error);
    });
  }

}
